<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
              {
            "num_cand": "U2FsdGVkX182El76Evxgv7pTdYZNpa3O5O/XxHc0b2M=",
            "cpf": "U2FsdGVkX1/UzNHkJ6KSQsJIUr5cyGCGSow+a4pRMIw="
          }, {
            "num_cand": "U2FsdGVkX18ceeIr6hx266p8WG2tAOW0AfYBEHrJaYA=",
            "cpf": "U2FsdGVkX1/LSLBa81Iivrpz1FfKQEjj0AGsneC/k60="
          }, {
            "num_cand": "U2FsdGVkX18Jodxa0xVczo8DvMYNQTcM8dn8uvbKx0w=",
            "cpf": "U2FsdGVkX19VP3yedEO2QcJEbDbx6m65G0QoyJLf09s="
          }, {
            "num_cand": "U2FsdGVkX19uQRnccfLNhNB5EEhniFZo96Pa7SujeiU=",
            "cpf": "U2FsdGVkX18Sz1o9F0yclfdZOp3ss12AC/bopAevOuM="
          }, {
            "num_cand": "U2FsdGVkX19cDV1GhuT7V+EbgJXpbAbBtWZtuEShCFk=",
            "cpf": "U2FsdGVkX1+yMmM7Nq9vnooATC3LM9NQUAqYCTuLr+w="
          }, {
            "num_cand": "U2FsdGVkX18a8lvjcQHQNJ7mK7aizOMXPNVlebrs26c=",
            "cpf": "U2FsdGVkX19L8MRCX7rb6sdfPawb7v199TSLyr9dG14="
          }, {
            "num_cand": "U2FsdGVkX19X+DykGEFp2gRq1OEey1BYEYbmi24ag+I=",
            "cpf": "U2FsdGVkX1+1hJMgvIJn76NVtZR4jYBwnuQzy+M4qPM="
          }, {
            "num_cand": "U2FsdGVkX1+sJ96aaWzYi6Q0rwNYC7dovJlJ3zI2TUc=",
            "cpf": "U2FsdGVkX18O1xikEvSpKx+J+vYviIv0dSpaE6LoY7c="
          }, {
            "num_cand": "U2FsdGVkX19clahxK6sJzPParQoV0vm1LcCy3KWUS+s=",
            "cpf": "U2FsdGVkX1/rjO0cIw0+6LUZj0HEGgjv+RI/He/AIPU="
          }, {
            "num_cand": "U2FsdGVkX1+iZwN18HKWxcmhCkTrzZm4hkGeQfPnvoY=",
            "cpf": "U2FsdGVkX1/AqGrh9kYZ4yepYlI2p3IGqO/GqThv0NI="
          }, {
            "num_cand": "U2FsdGVkX1+rR54aVKVkH70jw/ODdpdgZ+FZ1CPmynY=",
            "cpf": "U2FsdGVkX1/6J9LJ20IVeiuajfZYDciZy8n/umxOKc4="
          }, {
            "num_cand": "U2FsdGVkX19GJxtpH/LqwQn7tzfGtBTtJVrBxNjEDis=",
            "cpf": "U2FsdGVkX1/t3VJ5ELicbndYbMyDb330g1s7hE3b5x8="
          }, {
            "num_cand": "U2FsdGVkX18y07iBp6uJ+ITQEByUFckhyv9Kydy0XXM=",
            "cpf": "U2FsdGVkX19/I5/taxBHfBHXyObfh4H9OLXHoTDYLTo="
          }, {
            "num_cand": "U2FsdGVkX1+l80rUFnqgIF9tz31pc0NS0uqX+RAEUcA=",
            "cpf": "U2FsdGVkX1/KeM/preOI3KUbr9t63C/UivrylfVwoWk="
          }, {
            "num_cand": "U2FsdGVkX199F7nbkxjmCdJ50BYrZkrJL9gmodQ+8X0=",
            "cpf": "U2FsdGVkX1/J5SUp/jm2lVY0Iflcqe8is/mCVLEOhNY="
          }, {
            "num_cand": "U2FsdGVkX1+9SOtlvnWDnPlfPkE8q76PZ9uWUe5H390=",
            "cpf": "U2FsdGVkX1+I4i2aMWp1BwVtw2MbozQDxWhpefwK2ss="
          }, {
            "num_cand": "U2FsdGVkX1/Hm5Qx9FCM68stdJhIE9n48eXcXGoRhEY=",
            "cpf": "U2FsdGVkX19NuSAKZ+r5bqVqC0BWbZ+vSVInw3kHdts="
          }, {
            "num_cand": "U2FsdGVkX18iaGCNSxW+8BEZZApJazo2Wb51scWhZ7w=",
            "cpf": "U2FsdGVkX1+f1ypqydqrasU8MKBjl6xeBnxsfDiTAc8="
          }, {
            "num_cand": "U2FsdGVkX19vLFdLIrfgHNJ7EIYsotNOfa/3jfFGYTg=",
            "cpf": "U2FsdGVkX1/EnMA29JS1oX/RcqVYhaSh42/rbaFZsKo="
          }, {
            "num_cand": "U2FsdGVkX1+RtploNDKQaYTSVmMtt0SOQC3bwc2Pm30=",
            "cpf": "U2FsdGVkX1/79KqdfHAMeXKfCwt3fVpbbBidsqXuXBQ="
          }, {
            "num_cand": "U2FsdGVkX1+r5Awn5ndjDkq+0vGyvs9vYc7MFeLVqGY=",
            "cpf": "U2FsdGVkX1+A0DaUcyBohUy0q8q07d+hhi/WfVBSybg="
          }, {
            "num_cand": "U2FsdGVkX19lfSpoyYAdPuqvMzuEF9PTK3DOspNGpdU=",
            "cpf": "U2FsdGVkX19r4ApAVO9/9AaQGLNZKSKoB18RkxMbSqY="
          }, {
            "num_cand": "U2FsdGVkX1+wOAcdj4/6hPdOll75W4g4n1ymqjc+wm8=",
            "cpf": "U2FsdGVkX19vC7BqvMOHwEvtpKdIt6Pr9PcVNb39AbU="
          }, {
            "num_cand": "U2FsdGVkX1+9lvGYxtni5YUceRqzLZAbb2WFZJ7RoB4=",
            "cpf": "U2FsdGVkX18hLStGCTw4b2Q5eVl0NHCrMjZ/rSEZdZ4="
          }, {
            "num_cand": "U2FsdGVkX1+ha1xvkekGWo39GuhjuUys+Z1rYnFtEZo=",
            "cpf": "U2FsdGVkX1/pjvNMMfGRdqPqQv62bXO/CT7M1+MFLF8="
          }, {
            "num_cand": "U2FsdGVkX19Qir9+lHgIN+lh1Z6VHwtwLUljpiN1VLU=",
            "cpf": "U2FsdGVkX1+QWZjH9BiHFN/SWRFJjBy6J6NlU8MxtCo="
          }, {
            "num_cand": "U2FsdGVkX1/M7JwAQgY9aRASlW68tsQMIpHI7dXks18=",
            "cpf": "U2FsdGVkX1+N4brSHx/JZcKTul3Uo0aM/4NgII0RWCk="
          }, {
            "num_cand": "U2FsdGVkX1+j+5MnhBxdi7ozK6emMtAcrMhwZ9MTxv4=",
            "cpf": "U2FsdGVkX1+3m6zMsOvgdoMEF+gZYS9+qUJBzby140c="
          }, {
            "num_cand": "U2FsdGVkX1/UbZVJ7Xc/FbLS33e+H5znyvIR8RpMo/I=",
            "cpf": "U2FsdGVkX1+8llr3MwbEfMsx5JaQ/oIWzE/r9bUYddg="
          }, {
            "num_cand": "U2FsdGVkX18sX6icgXQZbd5OYztmAj6MWqb2PlYFkWQ=",
            "cpf": "U2FsdGVkX18hJQKcaWl8VBSRPu6WC6yhRXL9gmvl3oI="
          }, {
            "num_cand": "U2FsdGVkX1+BiyUwUlY7vi5BZqczuah1ItnTol6JkGg=",
            "cpf": "U2FsdGVkX1/bD7qo/AUzz6XDSVqc6G437KdYxhGrtZo="
          }, {
            "num_cand": "U2FsdGVkX1/2qxQXJ4Y5sNXuC9ddydL/fXMQJqFDvH8=",
            "cpf": "U2FsdGVkX1+LvLSo3aN8q+8Jx9Lq/B2ZRx8I6KDdAPo="
          }, {
            "num_cand": "U2FsdGVkX18SRNG/ktJHXrYDqqKSiLd79+ILzTuFVYE=",
            "cpf": "U2FsdGVkX1+MjDGUuplCPZYQrel+CmEndgITV0w3poI="
          }, {
            "num_cand": "U2FsdGVkX19CklIWPkly3lvTBj62e1LlegeKCU+38zU=",
            "cpf": "U2FsdGVkX1/zqSSXHZ5ZgFusPaWaUNi8ZXYzTFmPuv4="
          }, {
            "num_cand": "U2FsdGVkX19eHR9TStjIQP0ukYQ533bqVh6iVnYDiDU=",
            "cpf": "U2FsdGVkX19SFxbVg29lYn1GLkfyL/NQBz4xncdTZbM="
          }, {
            "num_cand": "U2FsdGVkX1+A0vV2B+3KnG1UHO1Zzvc3i+jR9lAotc8=",
            "cpf": "U2FsdGVkX19hp5Qt0A0+ikt1y1P/0tuuHMX4dk/n29g="
          }, {
            "num_cand": "U2FsdGVkX1+/dYxtSLpk/AE4ED0jkpRC9iwk5xD4vwI=",
            "cpf": "U2FsdGVkX18dVMnaeGvnKRlJQHeIoeaZ13S1K6J5k78="
          }, {
            "num_cand": "U2FsdGVkX18HCS9U4X9k7Pzc7dz5E/nrc/sn9OnhRfg=",
            "cpf": "U2FsdGVkX1/qrtpisdrCMZHpVaYcC1hNq5oxd+UowhE="
          }, {
            "num_cand": "U2FsdGVkX1/pkJIXiysl1bzMV2EHQ2HQuTC9AoP5WGk=",
            "cpf": "U2FsdGVkX1/mNoeQRSVNCLXJPNYwNPJIIU6D0Id5ovI="
          }, {
            "num_cand": "U2FsdGVkX18ncWWrko4VS7zr0HIkE2vTkFPGSuztVXE=",
            "cpf": "U2FsdGVkX1/t2rZOkbTffS7aLphPqEmNAh9uVSDJnnA="
          }, {
            "num_cand": "U2FsdGVkX18a+G+Wh85uU19jKtppYSeh+pm01X3zMbA=",
            "cpf": "U2FsdGVkX1/pM7yMVFh9TT36/AHBdBtBGWwA6RPOeNA="
          }, {
            "num_cand": "U2FsdGVkX1+sLJMktPM7Cbh+juf2irCUaJIHUDiJWs0=",
            "cpf": "U2FsdGVkX1+VOfISsCpE3iLVx/hHNpPOAxmG4WnR+6U="
          }, {
            "num_cand": "U2FsdGVkX1+0RAziL2oJP49Gk9gWEQUlO/LPLbNkN1s=",
            "cpf": "U2FsdGVkX18YwX8EaQT/QJyUwjlXGu+84GC54kG+FDo="
          }, {
            "num_cand": "U2FsdGVkX185Ka31CX/xC3f2QPQUCL5Ch7RwzqUh18Q=",
            "cpf": "U2FsdGVkX19hJr9VrgLWstUkx8/iJq0toZXPE9JP2Pw="
          }, {
            "num_cand": "U2FsdGVkX1+1lXRAXINcTG5pUyUfKkI429hVnN/HHKQ=",
            "cpf": "U2FsdGVkX1+k6g3HP189e2a5w9tzZ+SwqxXnbkWlp8Q="
          }, {
            "num_cand": "U2FsdGVkX1/PqYcxpgM8C6jQacnVdCJn3MFToOzJTsw=",
            "cpf": "U2FsdGVkX18nz/J9uLeY8WkFuV14fDa27elf0tAN3BA="
          }, {
            "num_cand": "U2FsdGVkX195+xFJ9de+RlO1NhNTkfkFArQbR/iPJZs=",
            "cpf": "U2FsdGVkX18BOmE1tdsD7b/Us99iK5Qx44L3z12KbSk="
          }, {
            "num_cand": "U2FsdGVkX1/nYxNCRFE+rhgPe0j9StxELix0jp0jImU=",
            "cpf": "U2FsdGVkX19bysYCKjl/hzn+A0k7UyRGiVYZR06qGWE="
          }, {
            "num_cand": "U2FsdGVkX1855C3Au1Jbg9JSojrV7coD5VL8ddardGM=",
            "cpf": "U2FsdGVkX18ADlPouhXgncFigiX06yT/OcO3o042eRM="
          }, {
            "num_cand": "U2FsdGVkX182UdX3/0MKEV3jZ4ftO8luvi7VTQnPhsQ=",
            "cpf": "U2FsdGVkX18mCBclhB4lUi5BQnK15HP/wPG2nunEq08="
          }, {
            "num_cand": "U2FsdGVkX1+l9YeKt8bd7uvvVN5+Q/p7ifayhC1zpMk=",
            "cpf": "U2FsdGVkX1+dEz/bp0WmHjbNkEeT5E65ul+pIOj4RRI="
          }, {
            "num_cand": "U2FsdGVkX1/WSoetUecP3UpXtJ36tWNSAKgf/WaLya8=",
            "cpf": "U2FsdGVkX192q1wgd+6EUWiD/Vdc1MxmWqAxHYmNsbk="
          }, {
            "num_cand": "U2FsdGVkX18H5Qe23nmoCdNN7FQEO7rRYlZaBoSAljg=",
            "cpf": "U2FsdGVkX19078SIDK6pQCXPtuui44prh6uUUYtnIVM="
          }, {
            "num_cand": "U2FsdGVkX1+xPgTgJb/WYkPmrMrb8JcH/EmK3savyHg=",
            "cpf": "U2FsdGVkX18fLk1bi3xJJ69CauOZTPB4+KDK0ir/lY4="
          }, {
            "num_cand": "U2FsdGVkX1/+/pswmjeCcInmrXYSBTEPqvDJ8SoSR2E=",
            "cpf": "U2FsdGVkX1/q4gHXN5fTq2Gayl+Wyyy+jSDySnRJ01U="
          }, {
            "num_cand": "U2FsdGVkX1/kdKi/W0gn9GKeTuAD0KDGRIQMEKxLpjM=",
            "cpf": "U2FsdGVkX19b1C2Q7DYKWWznmoP3AJuQ/nuhEZsun0s="
          }, {
            "num_cand": "U2FsdGVkX18UpWurq70pwSNh3bdH5dLijXqw7/MEsJ0=",
            "cpf": "U2FsdGVkX18vJ1RHmVPU33NHyXlCo6v6y1kIEQn/Kxo="
          }, {
            "num_cand": "U2FsdGVkX1/z67yGAbTCHvnY6/S9QQO3dAzlU9ifdcw=",
            "cpf": "U2FsdGVkX1/RIFHQOHgqKfpO034DCHYGGZSjniF8vVA="
          }, {
            "num_cand": "U2FsdGVkX19+HypmeA7XfESmRqs94jXeYFMYplEy3dw=",
            "cpf": "U2FsdGVkX1//K+11Y3bUwCvQPUPE++e8G52QOmdgZrY="
          }, {
            "num_cand": "U2FsdGVkX1+V82nqxA2rgolGn5XAxA55ETZXmip8lDw=",
            "cpf": "U2FsdGVkX190nQqm/qN0RCZUau6dmzSbq5HSZ9dhaZs="
          }, {
            "num_cand": "U2FsdGVkX186+PibJ087ETpQ2yo7uqZX0rZXMVK5lbE=",
            "cpf": "U2FsdGVkX1/F0W6WHfoOacxEe+wQz2Q3fQr8rhnIXpc="
          }, {
            "num_cand": "U2FsdGVkX1/DWBw65vsdSPGgWpNDEXShY6QTU256oyM=",
            "cpf": "U2FsdGVkX1+8vInbUIm/l/1uTpFrRQe/zD3zab3tOxY="
          }, {
            "num_cand": "U2FsdGVkX18TBIZDUdWkditQV3gwD+hTG88VnXOLtzw=",
            "cpf": "U2FsdGVkX1/Ha5MaKhBlDef4NeNhzgc1nSVUo7DTvyY="
          }, {
            "num_cand": "U2FsdGVkX18890d/2Bt5ZdlAqCrtzDCw3RDxEf4CR54=",
            "cpf": "U2FsdGVkX1/JbHDPmTuXAWOD2liRsan35AE9SYeeFPI="
          }, {
            "num_cand": "U2FsdGVkX18ZiNFi+aLot3cPmqVfsEclkGnQao+jX5s=",
            "cpf": "U2FsdGVkX18VNIt/8OmfbrhRGLZPSSpRzmdNasrZ1HM="
          }, {
            "num_cand": "U2FsdGVkX1/Jplp34zb29WCuf2zDyYJvMjZHkjdD8hg=",
            "cpf": "U2FsdGVkX19sI2k+JtkbAagTrwE5Mha5RYps1RbJ5L8="
          }, {
            "num_cand": "U2FsdGVkX1/VQ+B/dRNuaKDmIqRxXq6F4f4iHgfgxPE=",
            "cpf": "U2FsdGVkX194W+STo6qGmF0+9cuCt7pMKokzBGaXHuU="
          }, {
            "num_cand": "U2FsdGVkX1+xUnzJV7iSst0KsrN3NTMleEu3Eofja00=",
            "cpf": "U2FsdGVkX1+naKLbXmyrRe/d/iYTIrIhsalJb6bV/tc="
          }, {
            "num_cand": "U2FsdGVkX1/e6BHJJj6Rd3eCU7o9rK9ZKkgKs4A//L8=",
            "cpf": "U2FsdGVkX18rdjB7qWhOo2wvNpCtwsJqbUTkJH2W8Ys="
          }, {
            "num_cand": "U2FsdGVkX18e6VwW0bE6Gdm573YhV9qGYzQ1NpqFqIo=",
            "cpf": "U2FsdGVkX1+pLnXgPZs8Ka+nD09i0YZi0yLRCzZRwTs="
          }, {
            "num_cand": "U2FsdGVkX18JcqUHALZi2UP2tuP3f/G/he1zSCtIzn0=",
            "cpf": "U2FsdGVkX1+MZ7bBOnKoT4AGR3ZwZApYDtfP9Ulnc3k="
          }, {
            "num_cand": "U2FsdGVkX18LcYZ8uXKCjq4Azs8phWp7Rf1l5PukaN4=",
            "cpf": "U2FsdGVkX1+CW/0dymYc++pZJcPclZ5k0xCCc0P86tY="
          }, {
            "num_cand": "U2FsdGVkX1/j3Lf7WWG9smhG1EO0LDNeWNFlBi4GZ1o=",
            "cpf": "U2FsdGVkX197m/z1eXV9WIuoF6AFNdcnv9/mbOLfyEQ="
          }, {
            "num_cand": "U2FsdGVkX19wiZrCBGX58F5QTP+jZtsJC7DjCIkTIYo=",
            "cpf": "U2FsdGVkX1+cRmCLXuO045O0MZQapypTPojeWO4YjxQ="
          }, {
            "num_cand": "U2FsdGVkX1892+s3c2MPwP5kFzO7SJTjxu3b8zesVTs=",
            "cpf": "U2FsdGVkX19/vkkT0tRmkQ5c3A8PiQCZK0+CbL2wMZw="
          }, {
            "num_cand": "U2FsdGVkX1/8e/vARNWOHL9BdpLqcFEGGrGZoYwxulE=",
            "cpf": "U2FsdGVkX18q1bRG/UNdodijdWDQCqbX5OluJilY54Y="
          }, {
            "num_cand": "U2FsdGVkX1/yF/PA4KUIWyBXPJr+0EMez2UnDoeTsWM=",
            "cpf": "U2FsdGVkX19MKMR9St0jyNNV/Ua7/eprQYh9GefslYA="
          }, {
            "num_cand": "U2FsdGVkX1/8/ngW1PnEMOB8jDvapLnHv+rjiE5pMWI=",
            "cpf": "U2FsdGVkX1/2ySGGz2x68gI5KAHil90NpGrFGOiO2sk="
          }, {
            "num_cand": "U2FsdGVkX1+PSj5FY7DRvYMHTlIA/bGgmN6B2GJ1m0U=",
            "cpf": "U2FsdGVkX1/vmq0MUJJrWpYgH25iGhjwFNaKLw4NvBw="
          }, {
            "num_cand": "U2FsdGVkX1+zOr2GXO1wVlEp9E9nuRHsbPuTE1Td/IE=",
            "cpf": "U2FsdGVkX1+quC4UiidFUknLI0tid4Si9IcbqFCE/Jg="
          }]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2201/2201_prov_prat/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
